// Max compressed creative weight per screen group. The limits come from
// screens-v3 (`max_image_weight_bytes` / `max_video_weight_bytes` on each
// screen of /screens/filtered), computed from width, height and
// slot_duration (+50% tolerance, 150:1 video codec) per the "Peso máximo de creatividades"
// artifact. Dynamic (ZIP) creatives have no limit.

const BYTES_PER_MB = 1024 * 1024;

const toPositiveNumber = (value) => {
    const number = Number(value);
    return value !== null && Number.isFinite(number) && number > 0
        ? number
        : null;
};

// Strictest limit across the screens of a group (they share size and slot,
// so in practice all values are equal).
const minLimit = (screens, field) => {
    const limits = screens
        .map((screen) => toPositiveNumber(screen?.[field]))
        .filter((limit) => limit !== null);
    return limits.length ? Math.min(...limits) : null;
};

export const getScreensMaxWeights = (screens = []) => ({
    max_image_weight_bytes: minLimit(screens, 'max_image_weight_bytes'),
    max_video_weight_bytes: minLimit(screens, 'max_video_weight_bytes'),
});

export const getGroupMaxWeightBytes = (group, creativeProperties) => {
    if (!group || !creativeProperties) return null;
    if (creativeProperties.type === 'image') {
        return toPositiveNumber(group.max_image_weight_bytes);
    }
    if (creativeProperties.type === 'video') {
        return toPositiveNumber(group.max_video_weight_bytes);
    }
    return null;
};

// Only creatives whose weight is known (freshly dropped files) are checked;
// creatives loaded from an existing campaign carry no size.
export const exceedsGroupMaxWeight = (group, creativeProperties) => {
    const limit = getGroupMaxWeightBytes(group, creativeProperties);
    const size = toPositiveNumber(creativeProperties?.size);
    return limit !== null && size !== null && size > limit;
};

export const formatBytesAsMb = (bytes) => {
    const value = toPositiveNumber(bytes);
    return value === null ? null : `${(value / BYTES_PER_MB).toFixed(2)} MB`;
};
